import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=5183f9dc&scoped=true"
import script from "./MenuContainer.vue?vue&type=script&lang=ts"
export * from "./MenuContainer.vue?vue&type=script&lang=ts"
import style0 from "./MenuContainer.vue?vue&type=style&index=0&id=5183f9dc&prod&scoped=true&lang=scss"
import style1 from "./MenuContainer.vue?vue&type=style&index=1&id=5183f9dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183f9dc",
  null
  
)

export default component.exports